import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export interface NotificationSender {
  name?: string;
  email?: string;
  profileImage?: string;
}

export interface AppNotification {
  id?: string;
  _id?: string;
  title?: string;
  message?: string;
  createdAt: string;
  isRead: boolean;
  sender?: NotificationSender;
  broadcast?: {
    id?: string;
    title?: string;
    message?: string;
    [key: string]: any;
  };
  [key: string]: any; // Catch-all for other fields
}

export const notificationsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<
      CommonResponse & { data: { list: AppNotification[]; total: number; unreadCount?: number } },
      { page?: number; limit?: number; search?: string }
    >({
      query: (params) => ({
        url: END_POINTS.notifications,
        method: "GET",
        params,
      }),
      providesTags: ["NOTIFICATIONS"],
    }),

    markAllAsRead: builder.mutation<CommonResponse, void>({
      query: () => ({
        url: END_POINTS.readAllNotifications,
        method: "PUT",
      }),
      invalidatesTags: ["NOTIFICATIONS"],
    }),

    markAsRead: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.notifications}/${id}/read`,
        method: "PUT",
      }),
      invalidatesTags: ["NOTIFICATIONS"],
    }),

    deleteNotification: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.notifications}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["NOTIFICATIONS"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkAllAsReadMutation,
  useMarkAsReadMutation,
  useDeleteNotificationMutation,
} = notificationsApi;
